import { getTrackingId } from './Utils'

const VALIDATE_EMAIL_URL = `${process.env.API_HOST}/action-triggers/public/minigame/email-validator`

const DATA_URL = `${process.env.API_HOST}/action-triggers/public/minigame?tracking_id=`
const DATA_URL_POPUP = `${process.env.API_HOST}/action-triggers/public/popup?tracking_id=`

const POST_MINIGAME_URL = `${process.env.API_HOST}/action-triggers/public/minigame`

export async function validateEmail(email, node_uuid) {
  try {
    const response = await fetch(VALIDATE_EMAIL_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        node_uuid,
      }),
    })
    return { status: response.status, msg: await response.json() }
  } catch (e) {
    return false
    console.log(e)
  }
}

export async function submitMinigame(value) {
  try {
    const response = await fetch(POST_MINIGAME_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(value),
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`)
    }
    return response.json()
  } catch (e) {
    console.log(e)
  }
}

export async function fetchMiniGameData() {
  try {
    const trackingId = getTrackingId()
    const response = await fetch(DATA_URL + trackingId)
    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.status}`)
    }
    return response.json()
  } catch (e) {
    console.log(e)
  }
}

export async function fetchPopup() {
  try {
    const trackingId = getTrackingId()
    const responsePopup = await fetch(DATA_URL_POPUP + trackingId)
    if (!responsePopup.ok) {
      throw new Error(`Failed to fetch data: ${responsePopup.status}`)
    }
    return responsePopup.json()
  } catch (e) {
    console.log(e)
  }
}
